// Env-gated analytics. No tags load unless REACT_APP_GA4_ID is set (owner-confirmed).
// Only loads on the live site (blissbranding.com / *.blissbranding.com) — never on
// previews, *.emergent.host, or localhost. Loaded at idle/after first paint.
// Never send names, emails, messages, or onboarding text as parameters.
const GA_ID = process.env.REACT_APP_GA4_ID || "";
let loaded = false;

function isLiveHost() {
  const h = window.location.hostname;
  return h === "blissbranding.com" || h.endsWith(".blissbranding.com");
}

export function initAnalytics() {
  if (!GA_ID || loaded || !isLiveHost()) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  const load = () => {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
  };
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(load, { timeout: 4000 });
  } else {
    setTimeout(load, 1500);
  }
}

export function trackPageView(path, title) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", "page_view", { page_location: window.location.origin + path, page_title: title });
}

export function track(name, params = {}) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", name, params);
}

export function trackPurchaseOnce(order) {
  if (!GA_ID) return;
  const key = `ga_purchase_${order.order_id}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  track("purchase", {
    transaction_id: order.order_id,
    value: order.amount_total_cents / 100,
    currency: (order.currency || "usd").toUpperCase(),
    items: [{ item_id: order.offer_id, item_name: order.offer_name, quantity: 1 }],
  });
}
